/**
 * Vendor: Media Culture / The Trade Desk
 *
 * This controller handles pixel placement on the site. The init() method
 * is pasted in exact contents from vendor.
 *
 * Requires a Media Culture Synthetic User ID as generated by the
 * MediaCulture controller.
 */
const FlashTalking = {
	/**
	 * Pixels
	 */
	pixels: {
		conversion: `<script type="text/javascript">((function (e, t) {var n = function () {var e = t.createElement("iframe");e.src = "https://servedby.flashtalking.com/container/28894;140670;15898;iframe/?spotName=Quote_Complete&ftXCurrency=[%INSERT_TRANSACTION_CURRENCY_HERE%]&ftXName=[%INSERT_TRANSACTION_NAME_HERE%]&ftXNumItems=[%INSERT_TRANSACTION_QUANTITY_HERE%]&ftXRef=[%INSERT_TRANSACTION_ID_HERE%]&ftXType=[%INSERT_TRANSACTION_TYPE_HERE%]&ftXValue=[%INSERT_TRANSACTION_VALUE_HERE%]&cachebuster=" + (Math.random() * 1e6);e.style.cssText="position: absolute;visibility: hidden;width: 1px;height: 1px;";t.body.appendChild(e)};if(t.readyState==="complete"){n()}else{if(typeof e.addEventListener!=="undefined"){t.addEventListener("DOMContentLoaded",n,false)}else{e.attachEvent("onload",n,false)}}})(window,document));</script>`,
		ctc: `<script type="text/javascript">((function (e, t) {var n = function () {var e = t.createElement("iframe");e.src = "https://servedby.flashtalking.com/container/28894;140671;15898;iframe/?spotName=Click_to_Call&ftXCurrency=[%INSERT_TRANSACTION_CURRENCY_HERE%]&ftXName=[%INSERT_TRANSACTION_NAME_HERE%]&ftXNumItems=[%INSERT_TRANSACTION_QUANTITY_HERE%]&ftXRef=[%INSERT_TRANSACTION_ID_HERE%]&ftXType=[%INSERT_TRANSACTION_TYPE_HERE%]&ftXValue=[%INSERT_TRANSACTION_VALUE_HERE%]&cachebuster=" + (Math.random() * 1e6);e.style.cssText="position: absolute;visibility: hidden;width: 1px;height: 1px;";t.body.appendChild(e)};if(t.readyState==="complete"){n()}else{if(typeof e.addEventListener!=="undefined"){t.addEventListener("DOMContentLoaded",n,false)}else{e.attachEvent("onload",n,false)}}})(window,document));</script>`
	},
	/**
	 * Init method
	 * (contents pasted exactly from vendor)
	 */
	init: function() {
		// Universal Script/Pixel
		var ft_onetag_15897 = {
			ft_vars:{
				"ftXRef": MediaCulture._getSUID(), // <-- INSERT "TRANSACTION_ID" --
				"ftXValue":"", // <-- INSERT "TRANSACTION_VALUE" --
				"ftXType":"", // <-- INSERT "TRANSACTION_TYPE" --
				"ftXName":"", // <-- INSERT "TRANSACTION_NAME" --
				"ftXNumItems":"", // <-- INSERT "TRANSACTION_QUANTITY" --
				"ftXCurrency":"", // <-- INSERT "TRANSACTION_CURRENCY" --
				},
			ot_dom:'https://servedby.flashtalking.com',
			ot_path:'/container/28894;140664;15897;iframe/?',
			ot_href:'ft_referrer='+escape(document.location.href),
			ot_rand:Math.random()*1000000,
			ot_ref:document.referrer,
			ot_init:function(){
				var o=this,qs='',count=0,ns='';
				for(var key in o.ft_vars){
					qs+=(o.ft_vars[key]==''?'':key+'='+o.ft_vars[key]+'&');
				}
				count=o.ot_path.length+qs.length+o.ot_href+escape(o.ot_ref).length;
				ns=o.ot_ns(count-2000);
				var ifrm = document.createElement('iframe');
				  ifrm.style.cssText = 'width:1px;height:1px;position:absolute;display:none;';
				  ifrm.src = o.ot_dom + o.ot_path + qs + o.ot_href + encodeURIComponent('?~'+qs) + '&ns=' + ns + '&cb=' + o.ot_rand;
				  document.body.appendChild(ifrm);
			},
			ot_ns:function(diff){
				if(diff>0){
					var o=this,qo={},
						sp=/(?:^|&)([^&=]*)=?([^&]*)/g,
						fp=/^(http[s]?):\/\/?([^:\/\s]+)\/([\w\.]+[^#?\s]+)(.*)?/.exec(o.ot_ref),
						ro={h:fp[2],p:fp[3],qs:fp[4].replace(sp,function(p1,p2,p3){if(p2)qo[p2]=[p3]})};
					return escape(ro.h+ro.p.substring(0,10)+(qo.q?'?q='+unescape(qo.q):'?p='+unescape(qo.p)));
				}else{
					var o=this;
					return escape(unescape(o.ot_ref));
				}
					}
			}
		ft_onetag_15897.ot_init();
	}
}


/**
 * Vendor: Media Culture / The Trade Desk
 *
 * This controller handles the generation of a vendor "Synthetic User ID" (SUID) and pixel
 * placement on site pages. The SUID is passed through in form conversions (through hidden field)
 * as well as in pixel scripts themselves.
 *
 * Requires this script to be included on the page AHEAD of initialization:
 * <script src="https://js.adsrvr.org/up_loader.1.1.0.js" type="text/javascript"></script>
 */
const MediaCulture = {
	/**
	 * The Synthetic User ID
	 * A unique identifier.
	 */
	suid: '',
	/**
	 * Quote forms for generating leads
	 */
	$quoteForms: $('#gform_1, #gform_2, #gform_3, #gform_4'),
	/**
	 * Pixels
	 */
	pixels: {
		tradeDesk: {
			universal: `<script type="text/javascript">ttd_dom_ready(function(){"function"==typeof TTDUniversalPixelApi&&new TTDUniversalPixelApi().init("sw4wj8z",["i8co40h"],"https://insight.adsrvr.org/track/up")});</script>`,
			conversion: `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=sw4wj8z&ct=0:wn4roaz&fmt=3&td1={td1}"/>`,
			ctc: `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=sw4wj8z&ct=0:40aa74m&fmt=3&td1={td1}"/>`,
			session: `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=sw4wj8z&ct=0:15togpj&fmt=3"/>`
		},
		insp: {
			landingPg: `<img src="https://connect.blockboardtech.com/track/t?e=Impression&vr=1&d=eJwzNDc0MjIxNrAwMTY30jGyMLHQMTQzMjHSMbQ0t7TUMTQ3MIAQBjqhedl5.eV5OgZoEITQBcAUVBiqPS0xpzhVxxAAQMIX3Q--&m=1&op5=[VALUE-1]&op6=[VALUE-2]&op7=[VALUE-3]&op8=[VALUE-4]&op9=[VALUE-5]&op10=[VALUE-6]" width="1" height="1" border="0">`,
			freeQuotePg: `<img src="https://connect.blockboardtech.com/track/t?e=Impression&vr=1&d=eJwzNDc0MjIxNjQ2NDc01TGyMLHQMTQDCugYWppbWuoYmhsYQggDndC87Lz88jwgCxWCELoAmIIKQ7WnJeYUp.oYAgA_TBfb&m=1&op5=[VALUE-1]&op6=[VALUE-2]&op7=[VALUE-3]&op8=[VALUE-4]&op9=[VALUE-5]&op10=[VALUE-6]" width="1" height="1" border="0">`,
			conversion: `<img src="https://connect.blockboardtech.com/track/t?e=Impression&vr=1&d=eJwzNDc0MjIxNjQ1MjQx1jGyMLHQMTQzMjHRMbQ0t7TUMTQ3MIIQBjqhedl5.eV5QBYqBCF0ATAFFYZqT0vMKU7VMQQAP4IX3Q--&m=1&op5=[VALUE-1]&op6=[VALUE-2]&op7=[VALUE-3]&op8=[VALUE-4]&op9=[VALUE-5]&op10=[VALUE-6]" width="1" height="1" border="0">`
		}
	},
	/**
	 * INTERNAL
	 *
	 * Create the Synthetic User ID
	 */
	_createSUID: function() {
		// @link https://paulius-repsys.medium.com/simplest-possible-way-to-generate-unique-id-in-javascript-a0d7566f3b0c
		const randomness = Math.random().toString(36).substr(2);
		this.suid = randomness;
	},
	/**
	 * INTERNAL
	 *
	 * Get the Synthetic User ID
	 *
	 * @returns string
	 */
	_getSUID: function() {
		return this.suid;
	},
	/**
	 * Replaces a placeholder value in a string with the
	 * Synthetic User ID.
	 *
	 * @param {string} pixel The pixel string with the placeholder that should be replaced
	 * @param {string} placeholder The placeholder value that should be replaced
	 * @returns string
	 */
	_getPixelWithSUID: function(pixel, placeholder) {
		return pixel.replace(placeholder, this._getSUID());
	},
	/**
	 * Prefill form fields with the SUID
	 */
	_prefillFormFields: function() {
		MediaCulture.$quoteForms.find('input[data-prefill="suid"]').each((i, el) => {
			$(el).val(MediaCulture._getSUID());
		});
	},
	/**
	 * Init Method
	 */
	init: function() {
		this._createSUID();
		this._prefillFormFields();
	},
	/**
	 * Fire pixels that should be fired on all pages
	 */
	fireOnAllPages: function() {
		Globals.$body.append(this.pixels.tradeDesk.universal);
		Globals.$body.append(this.pixels.tradeDesk.session);
		Globals.$body.append(this._getPixelWithSUID(this.pixels.insp.landingPg, '[VALUE-1]'));
	},
	/**
	 * Fire pixels that should only be fired on quote form pages.
	 */
	fireOnQuoteFormPages: function() {
		if (this.$quoteForms.length > 0) {
			Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.insp.freeQuotePg, '[VALUE-1]'));
		}
	},
	/**
	 * Fire pixels on form submissions
	 */
	fireOnConversion: function() {
		var quoteFormIds = this.$quoteForms.map(function(){return parseInt(this.getAttribute('data-formid'))}).get();

		$(document).on('gform_post_render', function(event, formId) {
			// All forms are set to redirect to a TY page so if we are redirecting, the form submitted successfully
			if (window['gformRedirect'] && quoteFormIds.indexOf(formId) !== -1) {
				Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.tradeDesk.conversion, '{td1}'));
				Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.insp.conversion, '[VALUE-1]'));
				Globals.$body.append(MediaCulture._getPixelWithSUID(FlashTalking.pixels.conversion, '[%INSERT_TRANSACTION_ID_HERE%]'));
			}
		});
	},
	/**
	 * Fire pixels on click to call anchor links.
	 */
	fireOnClickToCall: function() {
		$('a[href^="tel:"]').on('click', function() {
			Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.tradeDesk.ctc, '{td1}'));
			Globals.$body.append(MediaCulture._getPixelWithSUID(FlashTalking.pixels.ctc, '[%INSERT_TRANSACTION_ID_HERE%]'));
		});
	}
}

/**
 * Vendor: Media Culture / The Trade Desk
 *
 * Initialize all functions on $(document).ready
 */
$(() => {
	MediaCulture.init();
	FlashTalking.init();
	MediaCulture.fireOnAllPages();
	MediaCulture.fireOnQuoteFormPages();
	MediaCulture.fireOnClickToCall();
	MediaCulture.fireOnConversion();
});
